import { GridActionsCellItem, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import { createElement } from "react";
import { TbUserX } from "react-icons/tb";

import { useTrackingActions } from "@/stores/use-tracking-table";
import { IPlanPassenger } from "@/types/tasks.types";

import TrackingDetailActionHeader from "./TrackingDetailActionHeader";

export enum TrackingDetailClickActionNames {
    PASSENGER_UNASSIGN = "PASSENGER_UNASSIGN",
}

export const trackingDetailActions: {
    label: string;
    icon: React.ElementType;
    color: string;
    showInMenu?: true;
    onClick: TrackingDetailClickActionNames;
    mobile: boolean;
}[] = [
    {
        label: "Yolcuyu görevden çıkar",
        icon: TbUserX,
        color: "primary" as const,
        onClick: TrackingDetailClickActionNames.PASSENGER_UNASSIGN,
        showInMenu: true,
        mobile: true,
    },
];

function TrackingDetailActionsColumn({
    allRows,
    selectedRowIds,
}: {
    allRows: IPlanPassenger<"api">[];
    selectedRowIds: GridRowSelectionModel;
}): GridColDef<IPlanPassenger<"api">> {
    return {
        field: "actions",
        type: "actions",
        width: 60,
        cellClassName: "!px-2",
        pinnable: true,
        filterable: false,
        editable: false,
        disableColumnMenu: true,

        renderHeader: () => <TrackingDetailActionHeader allRows={allRows} selectedRowIds={selectedRowIds} />,
        getActions: (params) => {
            const { updateShowBulkUnassignDialog } = useTrackingActions();

            const clickActions: Record<TrackingDetailClickActionNames, { cb: () => void; cond: boolean }> = {
                [TrackingDetailClickActionNames.PASSENGER_UNASSIGN]: {
                    cb: () =>
                        updateShowBulkUnassignDialog({
                            ids: [params.row.id],
                            totalPassengers: allRows.length,
                        }),
                    cond: true,
                },
            };
            return trackingDetailActions
                .filter((action) => clickActions[action.onClick].cond)
                .map((action) => (
                    <GridActionsCellItem
                        icon={createElement(action.icon, { size: 14 })}
                        label={action.label}
                        onClick={clickActions[action.onClick].cb}
                        color={action.color}
                        showInMenu={action.showInMenu as true}
                        key={action.label}
                    />
                ));
        },
    };
}

export default TrackingDetailActionsColumn;
